/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Author_TrainerInputs */

const en_us2_draft_author_trainer = /** @type {(inputs: Draft_Author_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your trainer's draft`)
};

const pt_br2_draft_author_trainer = /** @type {(inputs: Draft_Author_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rascunho do seu personal`)
};

const es_419_draft_author_trainer = /** @type {(inputs: Draft_Author_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrador de tu entrenador`)
};

const pt_pt2_draft_author_trainer = /** @type {(inputs: Draft_Author_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rascunho do teu treinador`)
};

const fr_fr2_draft_author_trainer = /** @type {(inputs: Draft_Author_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brouillon de ton coach`)
};

const de_de2_draft_author_trainer = /** @type {(inputs: Draft_Author_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf deines Coachs`)
};

const it_it2_draft_author_trainer = /** @type {(inputs: Draft_Author_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bozza del tuo coach`)
};

/**
* | output |
* | --- |
* | "Your trainer's draft" |
*
* @param {Draft_Author_TrainerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_author_trainer = /** @type {((inputs?: Draft_Author_TrainerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Author_TrainerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_author_trainer(inputs)
	if (locale === "es-419") return es_419_draft_author_trainer(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_author_trainer(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_author_trainer(inputs)
	if (locale === "de-DE") return de_de2_draft_author_trainer(inputs)
	if (locale === "it-IT") return it_it2_draft_author_trainer(inputs)
	return en_us2_draft_author_trainer(inputs)
});
export { draft_author_trainer as "draft.author_trainer" }